import { Box, Typography, Modal, Button } from "@mui/material";

const CustomResultModal = ({
  open,
  handleClose,
  score,
  totalQuestions,
  correctAnswers,
  wrongAnswers,
  handleViewSolutions,
  isLoading,
  isError,
  retakesRemaining = 0,
  answersViewed = false,
  onRetake,
}) => {
  const scoreNum = parseFloat(score) || 0;
  const isAllCorrect = totalQuestions > 0 && correctAnswers === totalQuestions;
  const showRetake = retakesRemaining > 0 && !answersViewed && !isAllCorrect && typeof onRetake === "function";

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          padding: "2em",
          borderRadius: "12px",
          width: { xs: "90%", sm: "80%", md: "50%" },
          textAlign: "center",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        {isLoading ? (
          <Typography>Loading results...</Typography>
        ) : isError ? (
          <Typography color="error">Error loading results</Typography>
        ) : (
          <>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
              Quiz Results
            </Typography>
            <Box
              sx={{
                mb: 2,
                p: 2,
                bgcolor: (t) => t.palette.mode === "dark" ? "rgba(144,202,249,0.1)" : "#F0F8FF",
                borderRadius: "8px",
              }}
            >
              <Typography variant="h4" sx={{ color: "primary.main", fontWeight: 700 }}>
                {score}%
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Score
              </Typography>
            </Box>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2 }}>
              <Box
                sx={{
                  p: 1,
                  bgcolor: (t) => t.palette.mode === "dark" ? "rgba(102,187,106,0.1)" : "#E8F5E9",
                  borderRadius: "8px",
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: 600, color: "success.main" }}>
                  {correctAnswers}
                </Typography>
                <Typography variant="caption" color="text.secondary">Correct</Typography>
              </Box>
              <Box
                sx={{
                  p: 1,
                  bgcolor: (t) => t.palette.mode === "dark" ? "rgba(229,115,115,0.1)" : "#FFEBEE",
                  borderRadius: "8px",
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: 600, color: "error.main" }}>
                  {wrongAnswers}
                </Typography>
                <Typography variant="caption" color="text.secondary">Wrong</Typography>
              </Box>
            </Box>
            {showRetake && (
              <Box
                sx={{
                  mb: 2,
                  p: 1.5,
                  bgcolor: (t) => t.palette.mode === "dark" ? "rgba(144,202,249,0.05)" : "#F5F5F5",
                  borderRadius: "8px",
                  border: "1px dashed",
                  borderColor: "primary.light",
                }}
              >
                <Typography variant="caption" color="text.secondary">
                  {retakesRemaining} retake{retakesRemaining !== 1 ? "s" : ""} remaining
                </Typography>
              </Box>
            )}
            {showRetake && (
              <Button
                variant="contained"
                color="primary"
                onClick={onRetake}
                fullWidth
                sx={{ mt: 1 }}
              >
                Retake Quiz
              </Button>
            )}
            <Button
              variant={showRetake ? "outlined" : "contained"}
              onClick={handleViewSolutions}
              fullWidth
              sx={{ mt: showRetake ? 1 : 2 }}
            >
              View Solutions{showRetake ? " (uses retake)" : ""}
            </Button>
            <Button
              variant="outlined"
              onClick={handleClose}
              fullWidth
              sx={{ mt: 1 }}
            >
              Close
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default CustomResultModal;

